app.controller('popupVaccinationAndSerumUpdateController', ['$scope', '$state', '$mdDialog', 'objectHelper', 'baseModel',
    'applicationModel', 'visitModel', 'userModel', 'patientModel', 'vaccinationAndSerumModel', 'vaccinationAndSerumToUpdate',
    'preview',
    function ($scope, $state, $mdDialog, objectHelper, baseModel, applicationModel, visitModel, userModel, patientModel,
              vaccinationAndSerumModel, vaccinationAndSerumToUpdate, preview) {

        function setData() {
            $scope.vaccinationAndSerum = angular.copy(vaccinationAndSerumToUpdate);
            $scope.vaccinationAndSerum.patient = new PatientVO();
            $scope.vaccinationAndSerum.patient.id = $state.params.patientId;

            $scope.forms = {
                vaccinationAndSerumForm: null
            };

            $scope.vaccinationAndSerumActionType = 'update';
            $scope.presentDate = new Date();

            $scope.previewOnly = preview || ($scope.vaccinationAndSerum.author.userType === 'DOCTOR' && $scope.vaccinationAndSerum.author.id != userModel.currentUser.id);
        }

        function setPermissions() {
        }

        function setListeners() {
        }

        function setActions() {
            $scope.vaccinationAndSerumAction = function () {

                $scope.forms.vaccinationAndSerumForm.$setSubmitted();
                if ($scope.forms.vaccinationAndSerumForm.$valid) {
                    $scope.actionInProgress = true;

                    vaccinationAndSerumModel.update($scope.vaccinationAndSerum);

                    var successWatcherDisabler = $scope.$on(Event.VACCINATION_AND_SERUM.UPDATE.SUCCESS, function (event, result) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        $scope.actionInProgress = false;
                        $mdDialog.hide();
                    });
                    var errorWatcherDisabler = $scope.$on(Event.VACCINATION_AND_SERUM.UPDATE.ERROR, function (event, error) {
                        successWatcherDisabler();
                        errorWatcherDisabler();
                        $scope.actionInProgress = false;
                    });
                }
            };

            $scope.cancel = function() {
                $mdDialog.cancel();
            }
        }

        function configureInterface() {

        }

        function initialize() {
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);